export default "__VITE_ASSET__wh28IQ3Y__"